// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "aeroexpress__content-ZxLl9";
var _3 = "description-2acfk";
var _4 = "selectedService-20Ue6";
var _5 = "selectedService__content-h0xOI";
var _6 = "selectedService__date-3Q9GS";
var _7 = "selectedService__info-_MWCC";
var _8 = "selectedService__serviceClass-2Cz_J";
var _9 = "selectedService__price-1mkEs";
var _a = "description_not_selected-3_dwc";
var _b = "schedule-3CQ2m";
export { _1 as "__esModule", _2 as "aeroexpress__content", _3 as "description", _4 as "selectedService", _5 as "selectedService__content", _6 as "selectedService__date", _7 as "selectedService__info", _8 as "selectedService__serviceClass", _9 as "selectedService__price", _a as "description_not_selected", _b as "schedule" }
export default { "__esModule": _1, "aeroexpress__content": _2, "description": _3, "selectedService": _4, "selectedService__content": _5, "selectedService__date": _6, "selectedService__info": _7, "selectedService__serviceClass": _8, "selectedService__price": _9, "description_not_selected": _a, "schedule": _b }
